import { withUpxContext } from '../shared/components/upx-context';
import { MigrationAssistantPage } from './migration-assistant-page';

const MigrationAssistantPageWrapperWithUpxContext = withUpxContext(MigrationAssistantPage);
export default MigrationAssistantPageWrapperWithUpxContext;
